enum StatusDivida {
  AguardandoNegociacao = 1,
  EmNegociacao = 2,
  AguardandoPagamento = 3,
  Concluido = 4,
  Bloqueada = 5,
}

export default StatusDivida;
